const defaultPost = {
    method: "POST",
    cache: "no-cache",
    credentials: "omit",
    headers: {
        "Content-Type": "application/json",
    }
}

function withoutAuthorization(init) {
    return {
        ...init,
        headers: {
            ...init.headers,
        }
    }
}

function withBody(init, request) {
    return {
        ...init,
        body: JSON.stringify(request)
    }
}

export function publicRequestData(request) {
    return fetch("/api/portal/public/share/view",
        withBody(
            withoutAuthorization(defaultPost),
            request
        )
    )
}

export function publicRevokePermission(request) {
    return fetch("/api/portal/public/share/terminate",
        withBody(
            withoutAuthorization(defaultPost),
            request
        )
    )
}